var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.selectedChatClone._id, attrs: { id: "chat-viewer" } },
    [
      _c("div", { staticClass: "user-info-head" }, [
        _c(
          "span",
          { staticClass: "head-right" },
          [
            _c("Avatar", {
              staticClass: "sc-message--avatar",
              staticStyle: {
                color: "white",
                "font-size": "15px",
                "min-width": "40px !important",
              },
              attrs: {
                size: 40,
                username: _vm.getName() || "",
                src: _vm.getAgentImage(),
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "user-info" }, [
              _c("div", { staticClass: "user-name" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.getName()) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "user-mail-tel-head" }, [
                _c("span", { staticClass: "user-mail-tel" }, [
                  _vm._v(_vm._s(_vm.getEmail()) + " "),
                ]),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(0),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "messageListContainer",
          on: {
            dragenter: _vm.dragEnter,
            dragleave: _vm.dragLeave,
            dragover: _vm.dragOver,
            drop: _vm.dropBlock,
            paste: _vm.handleTPaste,
          },
        },
        [
          !_vm.dragMode
            ? _c("MessageList", {
                attrs: {
                  "always-scroll-to-bottom": true,
                  "scroll-top": false,
                  colors: _vm.colors,
                  "is-private-chat": true,
                  messages: _vm.getMessages(),
                  "random-bg-color-with-name": true,
                  participants: [{ _id: 1, name: "John Doe" }],
                  "show-avatar": true,
                  "show-typing-indicator": _vm.$t("message.customerTyping"),
                  ischatwindow: true,
                  "disable-translation": true,
                  contextMenuVisable: false,
                  firstUnreadMessage: _vm.getFirstUnreadMessage(),
                },
              })
            : _c("div", { staticClass: "dnd" }, [
                _c(
                  "h1",
                  { staticStyle: { "align-items": "center", color: "grey" } },
                  [_vm._v("Choose a file or drag it here!")]
                ),
              ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.show
        ? _c(
            "div",
            { staticClass: "uploading-wrapper" },
            [
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(_vm.uploadPercentage) +
                    "% uploaded... please wait"
                ),
              ]),
              _vm._v(" "),
              _c("a-progress", {
                attrs: {
                  showInfo: false,
                  percent: _vm.uploadPercentage,
                  status: "active",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { position: "relative" } },
        [
          _c("quill-editor", {
            ref: "myQuillEditor",
            staticStyle: { "max-height": "14%" },
            attrs: { id: "chat-editor", options: _vm.editorOption },
            on: {
              blur: function ($event) {
                return _vm.onEditorBlur($event)
              },
              ready: function ($event) {
                return _vm.onEditorReady($event)
              },
              change: function ($event) {
                return _vm.onEditorChange($event)
              },
            },
            model: {
              value: _vm.content,
              callback: function ($$v) {
                _vm.content = $$v
              },
              expression: "content",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                position: "absolute",
                "z-index": "999",
                top: "0",
                right: "0",
              },
              attrs: { slot: "toolbar", id: "toolbar" },
              slot: "toolbar",
            },
            [
              _c(
                "div",
                { staticClass: "voice-message" },
                [_c("VoiceRecorder", { attrs: { cb: _vm.sendVoiceMessage } })],
                1
              ),
              _vm._v(" "),
              _c(
                "md-button",
                { staticClass: "file-message", on: { click: _vm.selectFile } },
                [_c("md-icon", [_vm._v("attachment")])],
                1
              ),
              _vm._v(" "),
              _c(
                "md-button",
                { attrs: { id: "send-btn" }, on: { click: _vm.sendMessage } },
                [_c("send-icon")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticStyle: { "margin-right": "20px" } }, [
      _c("span", { staticClass: "material-icons ml-4" }, [_vm._v("search")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }